import { PowerFunnelUserStatuses } from './constants';
import { SubscriptionIntervalTypes } from '../../utils/constants';

/**
 * Derive the funnel-facing `userSubscriptionStatus` value used across the
 * annual-Power upgrade telemetry. The three buckets the funnel cares about are:
 *
 *  - `MONTHLY`        — any monthly Power subscriber (active or past-due monthly).
 *  - `POWER_PAST_DUE` — annual Power subscriber whose subscription is past-due.
 *  - `FREE`           — everyone else (the upsell target).
 *
 * `isMonthlySubscriber` is derived upstream (e.g. SideBar) and already folds in
 * past-due monthly users, so the `POWER_PAST_DUE` branch only catches the
 * past-due-annual case.
 */
export const deriveUserSubscriptionStatus = ({ user, isMonthlySubscriber } = {}) => {
    if (isMonthlySubscriber) {
        return PowerFunnelUserStatuses.MONTHLY;
    }
    if (user?.hasPastDueSubscription && user?.subscriptionTierType === SubscriptionIntervalTypes.YEAR) {
        return PowerFunnelUserStatuses.POWER_PAST_DUE;
    }
    return PowerFunnelUserStatuses.FREE;
};
